import styled from "styled-components";

import { Button } from "../../atoms/Button";
import { Typography } from "../../atoms/Typography";
import { AuthBase } from "./AuthBase";

type Props = {
  onSSOLoginClick: () => void;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 410px;
`;

const LoginButtonWrapper = styled.div`
  margin: 40px 0 22px 0;
  height: 44px;
`;

export function AuthContainerTmp({ onSSOLoginClick }: Props) {
  return (
    <AuthBase hasBackButton={false}>
      <Container>
        <LoginButtonWrapper>
          <Button buttonType="primary" onClick={onSSOLoginClick}>
            <Typography size={2}>Azure ADでログイン</Typography>
          </Button>
        </LoginButtonWrapper>
      </Container>
    </AuthBase>
  );
}
